import { render, staticRenderFns } from "./CountUsersBox.vue?vue&type=template&id=eb77e8d4"
import script from "./CountUsersBox.vue?vue&type=script&lang=js"
export * from "./CountUsersBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports